import { Star } from 'lucide-react';
import { useFavoriteStatus } from '../arches/favorites/hooks/useFavoriteStatus';

interface FavoriteButtonProps {
  archeId: string;
  className?: string;
}

// Arches that should not be added to desktop (navigation-level, not user-facing tools)
const NON_FAVORITABLE = new Set(['arche_favorites', 'arche_make_a_request']);

/**
 * Grid icon toggle button for adding/removing an arche from the desktop.
 * Uses optimistic UI — the icon fills/unfills immediately on click.
 */
export function FavoriteButton({ archeId, className = '' }: FavoriteButtonProps) {
  const { isFavorite, isLoading, toggle } = useFavoriteStatus(archeId);

  if (NON_FAVORITABLE.has(archeId)) {
    return null;
  }

  if (isLoading) {
    return (
      <button
        disabled
        className={`text-muted-foreground transition-colors ${className}`}
        title="Loading..."
      >
        <Star className="h-5 w-5" />
      </button>
    );
  }

  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle();
      }}
      className={`transition-colors hover:text-primary ${
        isFavorite ? 'text-primary' : 'text-muted-foreground'
      } ${className}`}
      title={isFavorite ? 'Remove from desktop' : 'Add to desktop'}
    >
      <Star className={`h-5 w-5 ${isFavorite ? 'fill-current' : ''}`} />
    </button>
  );
}
